import { InjectionToken } from '@angular/core';

export const SCHEDULE_INTERVAL_FORMGROUP = new InjectionToken<{}>('SCHEDULE_INTERVAL_FORMGROUP');
export const SCHEDULE_INTERVAL_FORMCONTROL = new InjectionToken<{}>('SCHEDULE_INTERVAL_FORMCONTROL');
